module.exports = __webpack_public_path__ + "static/media/29820012-pfR0wSgs.1f87604b.JPG";